module.exports = __webpack_public_path__ + "img/injective.c77756ae.png";